import _ from 'lodash';
import * as React from 'react';

import { Img, type ImgProps } from './img';

export interface ImgLogoProps extends BaseImgProps {
  logo: 'default' | 'contrast' | 'light';
  /**
   * Used to set the ratio of the image, the height will be based on the width.
   * @default 512
   */
  width?: number;
  /**
   * The theme mode, which determines the color scheme of the image.
   * @default 'dark'
   */
  mode?: 'dark' | 'light';
}

export const ImgLogo = React.forwardRef<HTMLImageElement, ImgLogoProps>(
  ({ logo, width = 512, ...props }, ref) => {
    const filename = React.useMemo(() => {
      switch (logo) {
        case 'contrast':
          return 'logo-full-contrast.png';
        case 'light':
          return 'logo-full-light.png';
        default:
          return 'logo-full.png';
      }
    }, [logo]);

    return (
      <Img
        {...props}
        ref={ref}
        alt={`Logo ${logo}`}
        src={`/brand/${filename}`}
        width={width}
        height={getHeight(width)}
      />
    );
  }
);
ImgLogo.displayName = 'ImgLogo';

const getHeight = (width: number) => {
  return width / 0.2673849167;
};

type BaseImgProps = Omit<ImgProps, 'src' | 'srcSet' | 'alt' | 'width' | 'height'>;
